import {
	createApp
} from 'vue'
import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import env from './env.js'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'
const app = createApp(App);

router.beforeEach((to, from, next) => {
 //beforeEach是router的钩子函数，在进入路由前执行
 if (to.meta.title) {
  //判断是否有标题
  // console.log(to.meta.title)
  document.title = to.meta.title
 } else {
  document.title = '默认title'
 }
 next()
})
app.config.globalProperties.$app = app;

app.config.globalProperties.isDev = function() {

	if (process.env.NODE_ENV === "production") return false;

	return true;

}

app.config.globalProperties.getEnv = function(key) {

	if (app.config.globalProperties.isDev()) return env['dev'][key];

	return env['pro'][key];
}

/**
 * 获取api域名
 */
app.config.globalProperties.getHost = function() {

	return app.config.globalProperties.getEnv('host');

}

/**
 * 获取前台域名
 */
app.config.globalProperties.webHost = function(webHost) {

	return app.config.globalProperties.getEnv('webHost');

}

/**
 * 获取图片域名
 */
app.config.globalProperties.getImgPrefix = function(imgHost) {
	return app.config.globalProperties.getEnv('imgHost');
	// let imgBaseUrl = 'http://img.cosonsen.com/product/'
	// return imgBaseUrl;
}

/**
 * 底层请求函数
 */
app.config.globalProperties.httpCommon = function(option) {
	// option.headers = {
	// 	'token': app.config.globalProperties.localGet('token'),
	// 	// 'rule':Vue.$route.path
	// };
	
	return new Promise((resolve, reject) => {
		option.baseURL = app.config.globalProperties.getHost();
		
		axios({
			method: option.method,
			url: option.baseURL + option.url,
			data: option.data,
			headers: option.headers
		}).then((res) => {
			if (res.data.code >= 10 && res.data.code <= 50) {

				reject(res.data);

				return router.push('/login');
			}

			if (res.data.code >= 51 && res.data.code <= 100) {

				reject(res.data);

				return false;
				// return this.$message.error(res.data.msg);
			}
			
			if (res.data.code ==101) {
			
				reject(res.data);
				return router.push({ name: 'PageNotFound'});
				// return this.$message.error(res.data.msg);
			}

			if (res.data.code == 1) {
				resolve(res.data);

			} else {

				this.$notify({
					title: '错误',
					message: res.data.msg,
					position: 'bottom-right',
					type: 'error'
				});


				reject(res.data);



			}



		}).catch((res) => {

			reject(res.data)

		});

	});


}



app.config.globalProperties.httpGet = function(option) {
	option.method = 'get';

	return new Promise((success, errs) => {

		app.config.globalProperties.httpCommon(option)
			.then((re) => {

				success(re)

			}).catch((err) => {

				errs(err)
			});

	});


}

app.config.globalProperties.httpPost = function(option) {
	option.method = 'post';

	return new Promise((success, errs) => {

		app.config.globalProperties.httpCommon(option)
			.then((re) => {
				success(re)

			}).catch((err) => {

				errs(err)
			});

	});


}


/**
 * 本地储存
 */
app.config.globalProperties.localSet = function(key, value, prefix = 'super_admin2.0_') {

	localStorage.setItem(prefix + key, value);
}



app.config.globalProperties.localGet = function(key, defaultValue = '', prefix = 'super_admin2.0_') {

	let re = localStorage.getItem(prefix + key);
	if (!re) return defaultValue;

	return re;

}


/**
 * 删除
 */
app.config.globalProperties.localRemove = function(key, prefix = 'super_admin2.0_') {

	localStorage.removeItem(prefix + key);

}

app.config.globalProperties.setItem = function(defaultItem, item) {

	// console.log(item);
	for (let key in defaultItem) {

		// console.log(item[key]);

		// console.log(typeof(item[key]));
		if (!(typeof(item[key]) == 'undefined')) {

			// console.log(item[key]);
			defaultItem[key] = item[key];
		}

	}
}
/**
 * 克隆对象
 * @param {Object} object
 */
app.config.globalProperties.cloneObj = function(object) {

	return JSON.parse(JSON.stringify(object))
}

/**
 * 重置对象
 * @param {Object} obj
 */
app.config.globalProperties.resetObj = function(obj) {

	for (let i in obj) {

		switch (typeof obj[i]) {

			case 'number':

				obj[i] = 0;

				break;

			case 'string':

				obj[i] = '';

				break;

			case 'object':


				// obj[i]=[];

				if (obj[i] instanceof Array) {

					obj[i] = [];

					break;
				}

				if (obj[i] instanceof Object) {

					obj[i] = {};

					break;
				}

				obj[i] = '';


				break;

			default:


				obj[i] = '';



		}

	}
}

//自定义  警告  弹窗
app.config.globalProperties.alertWarn = function(title) {
	return new Promise((success, fail) => {
		this.$notify({
			title: '警告',
			message: title,
			type: 'warning'
		});
	})
}

//自定义  成功  弹窗
app.config.globalProperties.alertSuccess = function(title) {
	return new Promise((success, fail) => {
		this.$notify({
			title: '成功',
			message: title,
			type: 'success'
		});
	})
}

//自定义  错误  弹窗
app.config.globalProperties.alertError = function(title) {
	return new Promise((success, fail) => {
		this.$notify({
			title: '错误',
			message: title,
			type: 'error'
		});
	})
}

app.config.globalProperties.messageCommon = function(title, message, type) {

	return new Promise((success, fail) => {

		this.$confirm(message, title, {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: type
		}).then(() => {

			success();
		}).catch(() => {
			// console.log('fail');
			fail();
		});

	});

}

app.config.globalProperties.messageSuccess = function(title, message) {


	return new Promise((success, fail) => {

		app.config.globalProperties.messageCommon(title, message, 'success').then(() => {

			success();

		}).catch(() => {

			fail();

		});

	});


}


/**
 * 弹窗+ajax请求
 *
 * @param title 弹窗标题
 * @param message 弹窗内容
 * @param url 请求地址
 * @param data 请求数据
 *
 */
app.config.globalProperties.msgBoxAjax = function(title, message, url, data = {}, customClass = 'custom-class') {

	return new Promise((success, fail) => {

		let i = this.$msgbox({
			title: title,
			customClass: customClass,
			message: message,
			showCancelButton: true,
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			// distinguishCancelAndClose:true
			closeOnClickModal: false,
			closeOnPressEscape: false,
			// closeOnHashChange: false,
			beforeClose: (action, instance, done) => {
				if (action === 'confirm') {

					console.log(instance);
					instance.confirmButtonLoading = true;
					instance.confirmButtonText = '执行中...';

					this.httpPost({
						url: url,
						data: data
					}).then((re) => {
						// console.log(re);
						done();

						instance.confirmButtonLoading = false;



						i.responseData = re;



					}).catch(() => {
						instance.confirmButtonLoading = false;
						done();
					});


				} else {
					done();
				}
			}
		}).then((action, instance, done) => {

			if (action == 'confirm') {

				success(i.responseData);
			} else {


			}

		}).catch(() => {


			fail();

		});


	});


}

// 单多文件上传
app.config.globalProperties.uploadFile = function(event, params = {}) {
	return new Promise((success, errs) => {
		// let file = event.target.files[0];
		let file = event.target.files;
		// console.log(file)
		let form = new FormData();
		for (let i in file) {
			form.append('file[]', file[i])
		}
		//额外参数
		for (let i in params) {
			form.append(i, params[i]);
		}
		// console.log(form)
		// return false;
		// form.append('file', file);
		app.config.globalProperties.httpPost({
			url: '/admin/upload/upload',
			data: form
		}).then((re) => {
			if (re.code == 1) {
				success(re)
			} else {
				errs(re)
			}
		}).catch((err) => {
			errs(err)
		})
	})
}


const originalPush = app.config.globalProperties.push
app.config.globalProperties.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}


app.config.globalProperties.routerSearch = function(context, query, rememberQuery = true) {
		// app.config.globalProperties.$AppContext=this;
  let c=app.config.globalProperties.$AppContext;
  let path = c.$route.path;
  let pathTemp=c.cloneObj(path);

  let temp = c.$route.query;

  let queryTemp=c.cloneObj(temp);

  let oldQuery = c.cloneObj(temp);

  let str='?';


  for(let key in query){

    if(key=='random') continue;

    let item = query[key];

    // oldQuery[key] = item;

    str+=key+'='+item+'&';


  }

  if(rememberQuery){

    /**
     * 记住原有参数
     * @param {Object} let key in temp
     */
    for (let key in temp) {

      if(key=='random') continue;

      if(findIndex(query,key)) continue;

      let item = temp[key];

      oldQuery[key] = item;

      str+=key+'='+item+'&';

    }

  }

  str=str.substr(0,str.length-1);

  str=str+'&random='+Math.random();
  // console.log(str)
  c.$router.push(pathTemp+str);

  c.reload();


}


function findIndex(array,index){


  for(let key in array){

    if(key==index) return true;


  }

  return false;

}

/**
 * 获取图片域名
 */
app.config.globalProperties.getImgPrefix = function() {
	return app.config.globalProperties.getEnv('imgHost');
	// let imgBaseUrl = 'http://img.cosonsen.com/product/'
	// return imgBaseUrl;
}

app.config.globalProperties.timestampToTime = function(timestamp) {
	var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
	// let Y = date.getFullYear() + '-';
	// let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
	// let D = date.getDate() + ' ';
	// let h = date.getHours() + ':';
	// let m = date.getMinutes() + ':';
	// let s = date.getSeconds();
	// return Y+this.padLeftZero(M)+this.padLeftZero(D)+this.padLeftZero(h)+this.padLeftZero(m)+this.padLeftZero(s);
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM;
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m;
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s;
	return y + '-' + MM + '-' + d;
}

// 判断俩个对象内容是否一致
app.config.globalProperties.isEqual = function(a,b) {
  //如果a和b本来就全等
  if(a===b){
    //判断是否为0和-0
    return a !== 0 || 1/a ===1/b;
  }
  //判断是否为null和undefined
  if(a==null||b==null){
    return a===b;
  }
  //接下来判断a和b的数据类型
  var classNameA=toString.call(a),
    classNameB=toString.call(b);
  //如果数据类型不相等，则返回false
  if(classNameA !== classNameB){
    return false;
  }
  //如果数据类型相等，再根据不同数据类型分别判断
  switch(classNameA){
    case '[object RegExp]':
    case '[object String]':
    //进行字符串转换比较
    return '' + a ==='' + b;
    case '[object Number]':
    //进行数字转换比较,判断是否为NaN
    if(+a !== +a){
      return +b !== +b;
    }
    //判断是否为0或-0
    return +a === 0?1/ +a === 1/b : +a === +b;
    case '[object Date]':
    case '[object Boolean]':
    return +a === +b;
  }
  //如果是对象类型
  if(classNameA == '[object Object]'){
    //获取a和b的属性长度
    var propsA = Object.getOwnPropertyNames(a),
      propsB = Object.getOwnPropertyNames(b);
    if(propsA.length != propsB.length){
      return false;
    }
    for(var i=0;i<propsA.length;i++){
      var propName=propsA[i];
      //如果对应属性对应值不相等，则返回false
      if(a[propName] !== b[propName]){
        return false;
      }
    }
    return true;
  }
  //如果是数组类型
  if(classNameA == '[object Array]'){
    if(a.toString() == b.toString()){
      return true;
    }
    return false;
  }
}

app.use(store).use(ElementPlus).use(router).use(VueClipboard).mount('#app')
